import { pick } from 'js/utils/ramda.util';
import { useMemo, useCallback } from 'react';
import { getDateForIms } from 'js/hooks/useFormatter/helpers';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as actions from '../store/actions';
import { ANOTHER_PERIOD_VALUE } from '../constants';
import { useDynamicReducerSelector, useDynamicReducerDispatch } from '../store';

export const useAnotherPeriodFilter = () => {
    const dispatch = useDynamicReducerDispatch();
    const translate = useComponentTranslations();
    const { period, startDate, isLoading } = useDynamicReducerSelector(pick(['period', 'startDate', 'isLoading']));

    const getIsDisabled = useCallback(({ from }) =>
        startDate === getDateForIms(new Date(from)), [startDate]);

    const onFromDateChange = useCallback(({ day, month, year }) => {
        const date = new Date(year, month, day, 0, 0, 0, 0);

        dispatch(actions.updateFrom(date));
    }, [dispatch]);

    return useMemo(() =>
        Number(period) === ANOTHER_PERIOD_VALUE
            ? {
                from: { label: translate('filter.from'), onChange: onFromDateChange, disabled: isLoading },
                until: { label: translate('filter.until'), disabled: true },
                submit: { title: translate('filter.btn.apply'), getIsDisabled }
            }
            : null,
        [period, translate, getIsDisabled, onFromDateChange, isLoading]);
};
